export default "__VITE_ASSET__0c103240__"